// Sentences taken from the Jeff-approved Florida claim fix, Rev 3
// (2026-09-25). Do not add legal claims beyond that package.

export const NOT_LEGAL_ADVICE = "This is not legal or engineering advice.";

export const FFPC_GENERALLY_SUBJECT =
    "High-rise condominium buildings are generally subject to the Florida Fire Prevention Code, which sets the dates: permits by January 1, 2026 and installation by January 1, 2027. F.S. 718.112(2)(n) requires condo associations to follow that code. SB 154 is the condo structural-inspection law, not a sprinkler retrofit law.";

export const HIGH_RISE_HEDGE =
    "The high-rise threshold is generally described in secondary sources. Confirm it with the local authority.";

export const FLORIDA_CITATION = `${FFPC_GENERALLY_SUBJECT} ${HIGH_RISE_HEDGE} ${NOT_LEGAL_ADVICE}`;
